<template>
  <div class="genericResourceModule">
    <router-view />
  </div>
</template>

<script>
/**
 * AI 模块入口统一拉取列表壳样式，避免子页用无 scoped 的 <style>@import 泄漏/重复。
 * CSS 从 JS import 仍进全局打包，但这是共享壳 token，应集中在入口而非散落各页。
 */
import '../genericResourceManage/linkListTheme.css'
import '../genericResourceManage/linkModuleSurfaces.css'
import '../genericResourceManage/linkTypography.css'
import '../genericResourceManage/linkListPageShell.css'
import '../genericResourceManage/linkControlBar.css'

export default {
  name: 'AiAssistantManageIndex',
}
</script>
